<template>
  <BoxButton @click="selectEstate" :selected="selected">
    <template #body>
      <div
        class="is-flex is-justify-content-space-between is-align-items-center"
        :data-e2e="EstateCypressAttribute.changeEstateModal.buttons.ESTATE"
      >
        <div class="is-flex is-flex-direction-column">
          <p class="title is-size-4">{{ estate.contact.fullName }}'s {{ estate.displayType }}</p>
          <p class="subtitle is-size-5">{{ jurisdictionName }}</p>
        </div>
        <span v-if="selected" class="tag">{{ $t('estate.current') }} {{ estate.displayType }}</span>
      </div>
    </template>
  </BoxButton>
</template>

<script>
import BoxButton from '/@/modules/core/ui/components/BoxButton.vue';
import { Estate } from '/@/modules/estate/models/Estate';
import JurisdictionService from '/@/modules/predefined/services/JurisdictionService';
import { EstateCypressAttribute } from '/@/modules/estate/constants/EstateCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EstateSelectionBoxButton',
  emits: ['select-estate'],
  components: {
    BoxButton
  },
  props: {
    estate: {
      type: Estate,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  static: {
    EstateCypressAttribute
  },
  computed: {
    jurisdictionName() {
      return JurisdictionService.getJurisdictionById(this.estate.jurisdictionId).name;
    }
  },
  methods: {
    selectEstate() {
      this.$emit('select-estate', this.estate);
    }
  }
};
</script>
